
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 20 20","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"stroke":"currentColor","stroke-width":"1.25","fill":"none","fill-rule":"evenodd","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{attrs:{"d":"M18.72 3.75l.594 12.47a.625.625 0 01-.594.654l-.03.001h-3.095M12.47.625l2.5 1.25c-1.103 5.124-2.56 7.81-5 8.75 0 0 2.5-6.875 2.5-10zm-5 0l-2.5 1.25c1.103 5.124 2.56 7.81 5 8.75 0 0-2.5-6.875-2.5-10zM1.22 3.75L.626 16.22a.625.625 0 00.625.655h3.094"}}),_c('path',{attrs:{"d":"M4.97 1.875L1.22 3.75l3.125 4.375V18.75c0 .345.28.625.625.625h1.875a2.5 2.5 0 002-1l1.125-1.5 1.125 1.5a2.5 2.5 0 002 1h1.875c.345 0 .625-.28.625-.625V8.125L18.72 3.75l-3.75-1.875M7.47.625h5m-2.5 10v6.25m-3.125-2.5h1.25m3.75 0h1.25"}})])])
          )
        }
      }
    